<ion-content>
  <ion-searchbar
    [(ngModel)]="searchTerm"
    (ionInput)="filterItems($event)">
  </ion-searchbar>

  <ion-list>
    <ion-item
      button
      *ngFor="let item of filteredItems"
      (click)="selectItem(item)">
      <ion-label>{{ item[displayKey] }}</ion-label>
      <ion-icon
        *ngIf="selected?.id === item.id"
        name="checkmark"
        slot="end">
      </ion-icon>
    </ion-item>
  </ion-list>
</ion-content>
